import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="page-not-found" className="bv-container py-32 md:py-44 min-h-[60vh]">
      <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#2BA8AD]">/ 404</p>
      <h1 className="h-display text-6xl md:text-8xl mt-6 leading-[0.95]">
        Pagina non trovata.
      </h1>
      <p className="mt-6 max-w-xl text-[17px] text-[#0E2E4D]/70">
        La pagina che cerchi è stata spostata o non è più disponibile.
      </p>
      <Link
        to="/"
        data-testid="not-found-cta"
        className="mt-10 inline-flex items-center gap-2 bg-[#0E2E4D] text-[#F5F2EB] px-7 py-4 text-[12px] tracking-[0.18em] uppercase font-mono hover:bg-[#2BA8AD] transition-colors"
      >
        Torna alla home <ArrowUpRight size={14} />
      </Link>
    </div>
  );
}
